import Markdown from 'markdown-to-jsx'

const AnchorSection = ({ section }) => {
  return (
    <>
      <span id={section.anchorName} className="anchor__section" />
      <h2>{section.title}</h2>
      {section.content && <Markdown>{section.content}</Markdown>}
    </>
  )
}

export default AnchorSection
